var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M50 11H0L11.09 0H39zM0 50V15h50v35H0zm6-29v6h25v-6H6zm0 11v6h14v-6H6z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }